import React, { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { getS3URL, handleViewsFormat } from "../../../_helpers";
import { courseActionsLabel } from "../../../_constants/staticData";
import axiosInstance from "../../../axios";
import { AuthorizedWrapper } from "../../Other/AuthorizedWrapper";
import { documentTypeUrl } from "../../../_constants/staticData";
import { useDispatch } from "react-redux";
import { courseActions } from "../../../_actions";
import { buildCourseDetailsURI } from "../../../_helpers";

export const CourseItem = ({
  item,
  getApprovedCourses,
  parseAndShortDescription,
  checkbox,
  handleChangeBundle,
  allbundle,
  selectedCourses,
  activeTab,
  url,
}) => {
  const [showModal, setShowModal] = useState({ state: false, type: "" });
  const [Bundle, setBundle] = useState(false);
  const dispatch = useDispatch();
  const handleClose = (event, key) => {
    event.preventDefault();
    setShowModal(false);

    if (key === "approve") {
      dispatch(courseActions.handleResetMyCourseList(activeTab));
      dispatch(courseActions.myCourses(activeTab, 1, url));
    } else if (key === "archive") {
      dispatch(courseActions.handleResetMyCourseList(activeTab));
      dispatch(courseActions.myCourses(activeTab, 1, url));
    }
  };

  const handleChange = () => {
    setBundle(!Bundle);
  };

  const handleShowModal = (type) => {
    setShowModal({ state: true, type: type });
  };
  const handleArchiveCourse = async (courseId) => {
    await axiosInstance
      .post("/course/status/update", { courseId: courseId, status: 4 })
      .then(() => {
        // dispatch(courseActions.myCourses("all", 1, "course"));
      });
  };

  const handleApproveCourse = async (courseId) => {
    await axiosInstance
      .post(
        "/course/status/update",
        JSON.stringify({
          courseId: courseId,
          status: 3,
        })
      )
      .then((res) => {
        dispatch(courseActions.myCourses("all", 1, "course"));
      })
      .catch((res) => console.log(res));
  };

  const getSubmitCallback = (type) => {
    switch (type) {
      case "approve":
        return handleApproveCourse;
      case "archive":
        return handleArchiveCourse;
      default:
        return null;
    }
  };

  const courseStatusCallback = (type) => {
    switch (type) {
      case 1:
        return { className: "text-draft", text: "Draft" };
      case 2:
        return { className: "text-review", text: "In Review" };
      case 3:
        return { className: "text-published", text: "Published" };
      case 4:
        return { className: "text-archive", text: "Archive" };
      default:
        return null;
    }
  };

  useEffect(() => {
    if (selectedCourses) {
      selectedCourses.courses.map((ele) => {
        if (ele.ID === item.ID) {
          return setBundle(true);
        } else {
          return false;
        }
      });
    }
  }, [selectedCourses]);

  return (
    <>
      <div
        className="main"
        style={{
          height: checkbox && "120px",
          backgroundColor: Bundle && "rgb(229, 229, 229)",
        }}
      >
        {checkbox && (
          <input
            type="checkbox"
            checked={Bundle}
            onChange={() => {
              handleChange(item);
              handleChangeBundle(item);
            }}
            style={{ width: "50px" }}
          />
        )}
        <div className="img-container" style={{ height: checkbox && "120px" }}>
          {allbundle ? (
            <>
              <img
                src={
                  item?.imageLink
                    ? getS3URL(item?.imageLink)
                    : documentTypeUrl.brokenImage
                }
                className="img"
              />
              <span className="bundlecourseitem">Bundle Courses</span>
            </>
          ) : (
            <img
              src={
                item.imageFiles != item.imageFiles.length > 0
                  ? getS3URL(item.imageFiles[0]?.fileName)
                  : documentTypeUrl.brokenImage
              }
              className="img"
              alt="courseImage"
            />
          )}
        </div>
        <div className="content">
          <div className="content-inner">
            <div className="inner-top">
              <div className="inner-top-flex">
                <div className="left">
                  <p className={courseStatusCallback(item?.Status)?.className}>
                    {courseStatusCallback(item?.Status)?.text}
                  </p>
                  <p className="course-category"> {item?.Category}</p>
                </div>
                <div className="right">
                  <p>{item.name}</p>
                  <p>{item.CourseName != null ? item?.CourseName : ""} </p>
                </div>
              </div>

              <div className="inner-top-flex">
                <p
                  className="description-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      item?.Description?.length > 120
                        ? parseAndShortDescription(item?.Description).substring(
                            0,
                            120
                          ) + "..."
                        : parseAndShortDescription(item?.Description),
                  }}
                ></p>

                <p
                  className="description-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      item?.description?.length > 120
                        ? parseAndShortDescription(item?.description).substring(
                            0,
                            120
                          ) + "..."
                        : parseAndShortDescription(item?.description),
                  }}
                ></p>
              </div>
              {!checkbox && (
                <div className="inner-mid-flex">
                  <div className="flex-item">
                    <p>Views</p>

                    {allbundle ? (
                      <p className="card-text">0</p>
                    ) : (
                      <p className="card-text">
                        {handleViewsFormat(
                          item?.courseViews === null ? 0 : item?.courseViews
                        )}
                      </p>
                    )}
                  </div>
                  <div className="flex-item">
                    <p>Enrollments</p>
                    {allbundle ? (
                      <p className="card-text">
                        {item?.price === null ? 0 : item?.price}
                        <img
                          src="https://cdn.edusity.com/icons/icon-enrolments.svg"
                          alt="icon"
                        />
                      </p>
                    ) : (
                      <p className="card-text">
                        {item?.enrollmentCount === null
                          ? 0
                          : item?.enrollmentCount}
                        <img
                          src="https://cdn.edusity.com/icons/icon-enrolments.svg"
                          alt="icon"
                        />
                      </p>
                    )}
                  </div>
                  <div className="flex-item">
                    <p> Total Earnings</p>
                    <p className="card-text">
                      &#36; 0
                      <img
                        src="https://cdn.edusity.com/icons/icon-wallet.svg"
                        alt="icon"
                      />
                    </p>
                  </div>
                  <div className="flex-item">
                    <p>Created Date</p>
                    {allbundle ? (
                      <p className="card-text">
                        {item?.createdAt &&
                          moment(item?.createdAt).format("MMM DD, YYYY")}
                      </p>
                    ) : (
                      <p className="card-text">
                        {item?.CreatedOn &&
                          moment(item?.CreatedOn).format("MMM DD, YYYY")}
                      </p>
                    )}
                  </div>
                  <div className="flex-item">
                    <p>Average Rating</p>
                    <p className="card-text">{item?.StarRating}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
          {!checkbox && (
            <div className="list-btn-div">
              <AuthorizedWrapper
                authorizedRoles={["Admin", "Instructor", "Institute"]}
              >
                {allbundle ? (
                  <>
                    <div className="view-section">
                      <Link
                        className="btn-edit-content quickview"
                        // to={{
                        //   pathname: `${buildCourseDetailsURI(
                        //     "",
                        //     item.name,
                        //     item.id,
                        //     item.id
                        //   )}`,
                        // }}
                      >
                        QUICK VIEW
                      </Link>
                    </div>
                    <div className="edit-section">
                      <Link
                        className="btn-edit-content edit-allcourse"
                        // to={{
                        //   pathname: `/dashboard/CourseEdit`,
                        //   state: { courseId: item.id, bundle: true },
                        // }}
                      >
                        Edit
                      </Link>
                    </div>
                  </>
                ) : (
                  <>
                    {item.Status !== 4 ? (
                      <>
                        <div className="view-section">
                          <Link
                            className="btn-edit-content quickview"
                            // to="/dashboard/categories/"
                            to={{
                              pathname: `/dashboard/categories/${item.ID}`,
                            }}
                          >
                            QUICK VIEW
                          </Link>
                        </div>
                        <div className="edit-section">
                          <Link
                            className="btn-edit-content edit-allcourse"
                            to={{
                              pathname: `/dashboard/CourseEdit/${item.ID}`,
                              state: { courseId: item.ID },
                            }}
                            // to="/dashboard/CourseEdit"
                          >
                            Edit
                          </Link>
                        </div>

                        <div className="delete-section">
                          <a
                            className="btn-edit-content archivedCourse"
                            onClick={() => handleShowModal("archive")}
                          >
                            ARCHIVE
                          </a>
                        </div>
                      </>
                    ) : null}
                  </>
                )}
              </AuthorizedWrapper>
              {!allbundle && (
                <AuthorizedWrapper authorizedRoles={["Admin", "Institute"]}>
                  {item.Status !== 3 && item.Status !== 4 && (
                    <div className="approve-section">
                      <Link
                        className="btn-edit-content"
                        to={{
                          pathname: "",
                        }}
                        onClick={() => handleShowModal("approve")}
                      >
                        APPROVE
                      </Link>
                    </div>
                  )}
                </AuthorizedWrapper>
              )}
            </div>
          )}
        </div>
        {showModal.state && (
          <ItemActionsOverlay
            courseId={item.ID}
            handleCancel={handleClose}
            handleSubmit={getSubmitCallback(showModal.type)}
            varient={showModal.type}
          />
        )}
      </div>
    </>
  );
};

const ItemActionsOverlay = ({
  courseId,
  varient,
  handleCancel,
  handleSubmit,
}) => {
  const [isSubmitting, setSubmitting] = useState(false);
  const handleClose = (event, key) => {
    handleCancel(event, key);
  };

  const handleSubmitCallback = (event, courseId) => {
    event.preventDefault();
    setSubmitting(true);
    handleSubmit(courseId);
  };
  return (
    <div className="item-popup">
      {isSubmitting ? (
        <>
          <div className="preview-close">
            <div onClick={(event) => handleClose(event, varient)}>
              <i className="icon check"></i>
            </div>
          </div>
          <div className="item-popup-text">
            <img
              src="https://cdn.edusity.com/icons/icon-complete-check.svg"
              alt="check-complete"
            />
            <p> Course status successfully updated.</p>
          </div>
        </>
      ) : (
        <>
          <div className="preview-close">
            <div onClick={handleClose}>
              <i className="icon check"></i>
            </div>
          </div>
          <div className="item-popup-text">{courseActionsLabel[varient]}</div>
          <div className="item-actions">
            <a className="btn-edit-content cancel" onClick={handleClose}>
              CANCEL
            </a>
            <a
              className="btn-edit-content quickview"
              href="javascript(void);"
              onClick={(event) => handleSubmitCallback(event, courseId)}
            >
              {varient}
            </a>
          </div>
        </>
      )}
    </div>
  );
};
